module.exports = __webpack_public_path__ + "img/自然灾害.d8687424.d8687424.jpg";